import { jsx as i, jsxs as b } from "react/jsx-runtime";
import { forwardRef as P } from "react";
import j from "../builders-icons/dist/systems/chevron-right.js";
import A from "../builders-icons/dist/systems/chevron-left.js";
import { useTracking as R } from "../utils.js";
import $ from "clsx";
import w from "./pagination.module.css.js";
import { ScreenReaderOnly as E } from "../screen-reader-only/screen-reader-only.js";
const u = "…", F = P(
  function({
    className: o,
    max: f,
    nextLabel: c = "→",
    // Fallback arrow added so consumers can smoothly upgrade with better text
    onChange: s,
    previousLabel: v = "←",
    // Fallback arrow added so consumers can smoothly upgrade with better text
    renderItem: x,
    tracking: M = !0,
    value: g,
    ...k
  }, y) {
    const I = $(w.pagination, o), S = R(M), m = x || O, r = Math.max(parseInt(String(f)), 1), t = Math.min(parseInt(String(g)), r), l = Math.max(1, Math.min(t - 1, r - 6 + 2)), d = Math.min(r, Math.max(t + 1, 5)), L = [
      ...l > 3 ? [1, u] : h(1, l - 1),
      ...h(l, d),
      ...d < r - 2 ? [u, r] : h(d + 1, r)
    ], p = (n) => () => {
      S({
        eventCategory: "pagination",
        eventAction: "click",
        eventLabel: `${n}`
      }), s == null || s(n);
    };
    return /* @__PURE__ */ i("nav", { className: I, ref: y, ...k, children: /* @__PURE__ */ b("ul", { children: [
      /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i(
        m,
        {
          "aria-disabled": t === 1,
          "aria-label": v,
          "data-testid": "prev",
          onClick: t > 1 ? p(t - 1) : void 0,
          value: Math.max(1, t - 1),
          children: /* @__PURE__ */ i(A, {})
        }
      ) }),
      L.map((n, N) => {
        const e = typeof n == "number";
        return /* @__PURE__ */ i("li", { "aria-hidden": !e || void 0, children: /* @__PURE__ */ i(
          m,
          {
            "aria-current": t === n,
            onClick: e ? p(Number(n)) : void 0,
            tabIndex: e ? void 0 : -1,
            value: e ? n : void 0,
            children: n
          }
        ) }, N);
      }),
      /* @__PURE__ */ b("li", { children: [
        /* @__PURE__ */ i(
          m,
          {
            "aria-disabled": t === r,
            "aria-label": c,
            "data-testid": "next",
            onClick: t < r ? p(t + 1) : void 0,
            value: Math.min(t + 1, r),
            children: /* @__PURE__ */ i(j, {})
          }
        ),
        /* @__PURE__ */ i(E, { "aria-live": "assertive", children: t })
      ] })
    ] }) });
  }
), O = (a) => /* @__PURE__ */ i("button", { type: "button", ...a }), h = (a, o) => Array.from({ length: o - a + 1 }, (f, c) => c + a);
export {
  F as Pagination
};
//# sourceMappingURL=pagination.js.map
